import { chatConfig } from "./config";
import type { ChatIdentity, ChatRoom } from "./types";

/* Win thresholds are tuned to the data that exists, not to what reads well.
   Across the newest 50 casino bets on the dev site the highest multiplier was
   10.5x and nothing cleared 100x [verified 2026-08-18], so the original x100
   could never fire and no win card had ever appeared. A card is still capped at
   one per minute per room (WIN_CARD_COOLDOWN_SECONDS), so a low bar sets the
   quality of what gets posted, not the volume. Raise these for a site with real
   traffic. */
const winThreshold = (fallback: number, override: string | undefined) => {
  const parsed = Number(override);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const ROOMS: ChatRoom[] = [
  {
    id: "general",
    label: "General Chat",
    allowedTierIds: null,
    winThreshold: winThreshold(2, process.env.CHAT_WIN_THRESHOLD),
  },
  {
    id: "high-rollers",
    label: "High Rollers",
    allowedTierIds: chatConfig.highRollerTierIds,
    winThreshold: winThreshold(5, process.env.CHAT_WIN_THRESHOLD_HIGH_ROLLERS),
  },
  {
    id: "sports",
    label: "Sports Talk",
    allowedTierIds: null,
    winThreshold: winThreshold(2, process.env.CHAT_WIN_THRESHOLD),
  },
];

export const DEFAULT_ROOM = ROOMS[0].id;

export const findRoom = (roomId: string) => ROOMS.find((room) => room.id === roomId) ?? null;

export const canEnter = (room: ChatRoom, identity: ChatIdentity | null) => {
  if (room.allowedTierIds === null) return true;
  if (!identity || identity.isGuest) return false;
  return identity.tierId !== null && room.allowedTierIds.includes(identity.tierId);
};

export const roomsFor = (identity: ChatIdentity | null) =>
  ROOMS.filter((room) => canEnter(room, identity));
